import styled, { keyframes } from 'styled-components';
import { Colors } from './Colors';
import { toRem } from './Utils';

const pulse = keyframes`
    50% { opacity: 0.5; }    
`;

export const Skeleton = styled.div<{ width?: string, height?: string, rounding?: string }>`
    ${p => p.width && `width: ${toRem(p.width)} !important;`}
    height: ${p => p.height ? `${toRem(p.height)} !important` : '1em'};
    background: ${Colors.gray200};
    border-radius: ${p => p.rounding ? toRem(p.rounding) : '9999px'};
    animation: ${pulse} 2s cubic-bezier(.4,0,.6,1) infinite;
`;
